import { CheckIcon } from '@/public/icon';
import { Typography } from '@mui/material';

type HelperTextProps = {
    show: boolean;
    error: string;
};

const HelperText = (props: HelperTextProps) => {
    const { show, error } = props;
    return (
        <>
            {show ? (
                <span
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                    }}
                >
                    <CheckIcon />
                    <Typography sx={{marginLeft: 2, color: '#FF4A4D' }} variant='h2_12Regular' lineHeight="100%">{error}</Typography>
                </span>
            ) : null}
        </>
    );
};

export default HelperText;
